import React, { useState, useEffect } from "react";
import {
  ButtonGroup,
  Button,
  Container,
  Content,
  FlexboxGrid,
  Header,
  DatePicker,
  Loader,
} from "rsuite";
import "./dashboard.css";
import moment from "moment/moment";
import { DashboardServices } from "../../../core/services/DashboardServices";
import { Line, Bar, Pie } from "react-chartjs-2";
import { useSelector } from "react-redux";
import { UtilityServices } from "../../../core/services/UtilityServices";
import { dateFormatObj } from "../../../core/config/AppConstants";
import {
  Chart,
  ArcElement,
  LineElement,
  BarElement,
  PointElement,
  BarController,
  BubbleController,
  DoughnutController,
  LineController,
  PieController,
  PolarAreaController,
  RadarController,
  ScatterController,
  CategoryScale,
  LinearScale,
  LogarithmicScale,
  RadialLinearScale,
  TimeScale,
  TimeSeriesScale,
  Decimation,
  Filler,
  Legend,
  Title,
  Tooltip,
} from "chart.js";

Chart.register(
  ArcElement,
  LineElement,
  BarElement,
  PointElement,
  BarController,
  BubbleController,
  DoughnutController,
  LineController,
  PieController,
  PolarAreaController,
  RadarController,
  ScatterController,
  CategoryScale,
  LinearScale,
  LogarithmicScale,
  RadialLinearScale,
  TimeScale,
  TimeSeriesScale,
  Decimation,
  Filler,
  Legend,
  Title,
  Tooltip
);

const Dashboard = () => {
  let userData = {
    userType: UtilityServices.getLoggedInUser("user_type"),
    selectedCompany: "",
    storeId: "",
  };
  const [currentUser, setCurrentUser] = useState(userData);
  const [selectedCompany, setSelectedCompany] = useState("");
  const [loader, setLoader] = useState(false);
  const userSelectedCompany = useSelector((state: any) => {
    return state?.company?.id;
  });
  let initialDashboardState = {
    graphType: ["Company", "Customer"],
    graphFilterOptions: ["Monthly"],
    selectedGraphType: "Company",
    selectedFilterOption: "Monthly",
    selectedFromDate: new Date(
      moment().subtract(12, "M").format(dateFormatObj.moment_y_m_d)
    ),
    selectedToDate: new Date(),
    activeTab: 1,
  };
  const [state, setState] = useState<any>(initialDashboardState);
  let aggregateReport = {
    dataLine: {
      labels: [],
      datasets: [
        {
          label: "Data 1",
          fill: true,
          lineTension: 0.3,
          backgroundColor: "rgba(225, 204,230, .3)",
          borderColor: "rgb(205, 130, 158)",
          borderCapStyle: "butt",
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: "miter",
          pointBorderColor: "rgb(205, 130,1 58)",
          pointBackgroundColor: "rgb(255, 255, 255)",
          pointBorderWidth: 10,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: "rgb(0, 0, 0)",
          pointHoverBorderColor: "rgba(220, 220, 220,1)",
          pointHoverBorderWidth: 2,
          pointRadius: 1,
          pointHitRadius: 10,
          data: [],
        },
        {
          label: "Data 2",
          fill: true,
          lineTension: 0.3,
          backgroundColor: "rgba(211, 153, 176, 1)",
          borderColor: "rgb(35, 26, 136)",
          borderCapStyle: "butt",
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: "miter",
          pointBorderColor: "rgb(35, 26, 136)",
          pointBackgroundColor: "rgb(255, 255, 255)",
          pointBorderWidth: 10,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: "rgb(0, 0, 0)",
          pointHoverBorderColor: "rgba(220, 220, 220, 1)",
          pointHoverBorderWidth: 2,
          pointRadius: 1,
          pointHitRadius: 10,
          data: [],
        },
      ],
    },
  };
  const [aggegateReportData, setAggregateReportData] = useState<any>({
    ...aggregateReport,
  });
  let pieChartData = {
    dataPie: {
      labels: ["Red", "Green", "Yellow", "Grey", "Dark Grey"],
      datasets: [
        {
          data: [],
          backgroundColor: [
            "#F7464A",
            "#46BFBD",
            "#FDB45C",
            "#949FB1",
            "#4D5360",
            "#AC64AD",
          ],
          hoverBackgroundColor: [
            "#FF5A5E",
            "#5AD3D1",
            "#FFC870",
            "#A8B3C5",
            "#616774",
            "#DA92DB",
          ],
        },
      ],
    },
  };
  const [monthlyNewCompany, setMonthlyNewCompany] = useState<any>({
    ...pieChartData,
  });
  let activeStoreData = {
    dataBar: {
      labels: [],
      datasets: [
        {
          label: "",
          data: [],
          backgroundColor: [
            "rgba(255, 134,159,0.4)",
            "rgba(98,  182, 239,0.4)",
            "rgba(255, 218, 128,0.4)",
            "rgba(113, 205, 205,0.4)",
            "rgba(170, 128, 252,0.4)",
            "rgba(255, 177, 101,0.4)",
          ],
          borderWidth: 2,
          borderColor: [
            "rgba(255, 134, 159, 1)",
            "rgba(98,  182, 239, 1)",
            "rgba(255, 218, 128, 1)",
            "rgba(113, 205, 205, 1)",
            "rgba(170, 128, 252, 1)",
            "rgba(255, 177, 101, 1)",
          ],
        },
      ],
    },
    barChartOptions: {
      responsive: true,
      maintainAspectRatio: true,
    },
  };
  const [activeStore, setActiveStore] = useState<any>({ ...activeStoreData });
  const handleTabs = (tabIndex: number) => {
    let obj = { ...state };
    obj.activeTab = tabIndex;
    if (tabIndex === 1) {
      obj.graphFilterOptions = ["Monthly"];
      obj.selectedFilterOption = "Monthly";
      obj.selectedFromDate = new Date(
        moment().subtract(12, "M").format(dateFormatObj.moment_y_m_d)
      );
      obj.selectedToDate = new Date();
    }
    if (tabIndex === 2) {
      obj.graphFilterOptions = ["Daily", "Monthly", "Weekly"];
      obj.selectedFilterOption = "Daily";
      obj.selectedFromDate = new Date(
        moment().subtract(1, "M").format(dateFormatObj.moment_y_m_d)
      );
      obj.selectedToDate = new Date();
    }
    setState({ ...obj });
  };

  useEffect(() => {
    let obj = { ...state };
    handleFilterWiseDate(obj.selectedFilterOption);
  }, [state.activeTab]);

  const handleGraphType = (event: any, selectedOpt: any) => {
    let obj = { ...state };
    obj.selectedFilterOption = selectedOpt;
    obj.selectedFromDate = new Date();
    obj.selectedToDate = new Date();
    setState({ ...obj });
    handleFilterWiseDate(selectedOpt);
  };

  const handleFilterWiseDate = (type: string) => {
    let obj = { ...state };
    let d1 = moment().subtract(1, "M").format(dateFormatObj.moment_y_m_d);
    if (type === "Daily") {
      obj.selectedFromDate = new Date(
        moment().subtract(1, "M").format(dateFormatObj.moment_y_m_d)
      );
      obj.selectedToDate = new Date();
    } else if (type === "Weekly") {
      obj.selectedFromDate = new Date(
        moment().subtract(3, "M").format(dateFormatObj.moment_y_m_d)
      );
      obj.selectedToDate = new Date();
    } else if (type === "Monthly") {
      obj.selectedFromDate = new Date(
        moment().subtract(12, "M").format(dateFormatObj.moment_y_m_d)
      );
      obj.selectedToDate = new Date();
    }
    obj.selectedFilterOption = type;
    setState({ ...obj });
  };

  async function getDashboradAdminReport(data: any) {
    try {
      setLoader(true);
      const response = await DashboardServices.getAdminAggregateReport(data);
      if (response && response.status === 200 && response.data) {
        setLoader(false);
        var activeStoreData1 = { ...activeStore };
        activeStoreData1.dataBar.labels = [];
        activeStoreData1.dataBar.datasets[0].data = [];

        var activeStoreData2 = { ...monthlyNewCompany };
        activeStoreData2.dataPie.labels = [];
        activeStoreData2.dataPie.datasets[0].data = [];
        if (
          response.data.data["company_by_active_store"] &&
          response.data.data["company_by_active_store"]["labels"]
        ) {
          activeStoreData1.dataBar.labels =
            response.data.data["company_by_active_store"]["labels"];
          activeStoreData1.dataBar.datasets[0].data =
            response.data.data["company_by_active_store"].series;
          setActiveStore({ ...activeStoreData1 });
        }
        if (
          response.data.data["monthly_new_company"] &&
          response.data.data["monthly_new_company"]["labels"]
        ) {
          activeStoreData2.dataPie.labels =
            response.data.data["monthly_new_company"]["labels"];
          activeStoreData2.dataPie.datasets[0].data =
            response.data.data["monthly_new_company"].series[0];
          setMonthlyNewCompany(activeStoreData2);
        }
      }
    } catch (error: any) {
      setLoader(false);
      UtilityServices.showToaster({ type: "error", message: error?.message });
    }
  }

  async function getDashboradAggregateReport(data: any) {
    try {
      setLoader(true);
      const response = await DashboardServices.getAggregateReport(data);
      if (
        response &&
        response.status === 200 &&
        response.data &&
        response.data.data
      ) {
        setLoader(false);
        var report = { ...aggegateReportData };
        report.labels = [];
        report.dataLine.labels = [];
        report.dataLine.datasets[0].data = [];
        report.dataLine.datasets[1].data = [];
        if (
          response.data.data["daily_new_customer"] &&
          response.data.data["daily_new_customer"]["labels"]
        ) {
          report.labels = response.data.data["daily_new_customer"]["labels"];
          report.dataLine.labels =
            response.data.data["daily_new_customer"]["labels"];
          report.dataLine.datasets[0].data =
            response.data.data["daily_new_customer"].series[0];
          report.dataLine.datasets[1].data =
            response.data.data["daily_new_customer"].series[1];
        }

        if (
          response.data.data["weekly_new_customer"] &&
          response.data.data["weekly_new_customer"]["labels"]
        ) {
          report.labels = response.data.data["weekly_new_customer"]["labels"];
          report.dataLine.labels =
            response.data.data["weekly_new_customer"]["labels"];
          report.dataLine.datasets[0].data =
            response.data.data["weekly_new_customer"].series[0];
          report.dataLine.datasets[1].data =
            response.data.data["weekly_new_customer"].series[1];
        }

        if (
          response.data.data["monthly_new_customer"] &&
          response.data.data["monthly_new_customer"]["labels"]
        ) {
          report.labels = response.data.data["monthly_new_customer"]["labels"];
          report.dataLine.labels =
            response.data.data["monthly_new_customer"]["labels"];
          report.dataLine.datasets[0].data =
            response.data.data["monthly_new_customer"].series[0];
          report.dataLine.datasets[1].data =
            response.data.data["monthly_new_customer"].series[1];
        }
        setAggregateReportData({ ...report });
      }
    } catch (error: any) {
      setLoader(false);
      UtilityServices.showToaster({ type: "error", message: error?.message });
    }
  }

  useEffect(() => {
    if (!state.selectedFromDate || !state.selectedToDate) {
      return;
    }
    if (state.selectedFromDate && state.selectedToDate) {
      let payload = {
        aggregate_for: {
          monthly_new_company: 1,
          company_by_active_store: 1,
        },
        params: {
          monthly_new_company: {
            start_date: moment(state.selectedFromDate).format(
              dateFormatObj.moment_y_m_d
            ),
            end_date: moment(state.selectedToDate).format(
              dateFormatObj.moment_y_m_d
            ),
          },
        },
        comp_id: selectedCompany,
      };
      let payload2 = {
        aggregate_for: {},
        comp_id: selectedCompany,
        params: {},
      };
      if (state.activeTab === 2) {
        switch (state.selectedFilterOption) {
          case "Daily":
            payload2.aggregate_for = { daily_new_customer: 1 };
            payload2.params = {
              daily_new_customer: {
                start_date: moment(state.selectedFromDate).format(
                  dateFormatObj.moment_y_m_d
                ),
                end_date: moment(state.selectedToDate).format(
                  dateFormatObj.moment_y_m_d
                ),
              },
            };
            break;
          case "Weekly":
            payload2.aggregate_for = { weekly_new_customer: 1 };
            payload2.params = {
              weekly_new_customer: {
                start_date: moment(state.selectedFromDate).format(
                  dateFormatObj.moment_y_m_d
                ),
                end_date: moment(state.selectedToDate).format(
                  dateFormatObj.moment_y_m_d
                ),
              },
            };
            break;
          case "Monthly":
            payload2.aggregate_for = { monthly_new_customer: 1 };
            payload2.params = {
              monthly_new_customer: {
                start_date: moment(state.selectedFromDate).format(
                  dateFormatObj.moment_y_m_d
                ),
                end_date: moment(state.selectedToDate).format(
                  dateFormatObj.moment_y_m_d
                ),
              },
            };
            break;
        }
      }
      if (currentUser && currentUser.userType === "b") {
        if (state.activeTab === 2) {
          getDashboradAggregateReport(payload2);
        } else if (state.activeTab === 1) {
          getDashboradAdminReport(payload);
        }
      } else if (currentUser && currentUser.userType === "c") {
        if (state.activeTab === 1) {
          let finalPayload = { ...payload };
          finalPayload.comp_id = UtilityServices.getLoggedInUser("company_id");
          getDashboradAggregateReport(finalPayload);
        }
      }
    }
  }, [state, selectedCompany]);

  useEffect(() => {
    let obj = { ...state };
    if (obj.activeTab === 1) {
      handleFilterWiseDate(obj.selectedFilterOption);
    }
  }, []);

  useEffect(() => {
    let obj = { ...state };
    handleFilterWiseDate(obj.selectedFilterOption);
  }, [state.activeTab]);

  useEffect(() => {
    setSelectedCompany(userSelectedCompany);
  }, [userSelectedCompany]);

  const handleDateChange = (date: any, fromOrToDateType: any) => {
    let obj = { ...state };
    fromOrToDateType === "from"
      ? (obj.selectedFromDate = date)
      : (obj.selectedToDate = date);
    setState({ ...obj });
  };

  return (
       
    <Container className="container ds-contnr">
      {loader && (
        <Loader
          style={{ zIndex: 9999 }}
          size="lg"
          backdrop
          content="Loading..."
          vertical
        />
      )}
      <Header className="header dashboard-hdr">
        <FlexboxGrid justify="space-between">
          <FlexboxGrid.Item colspan={7}>
            <div className="dsb-tab1">
              <Button
                className={
                  state.activeTab === 1
                    ? "menu-default-active menu-default"
                    : "menu-default"
                }
                onClick={(e: any) => handleTabs(1)}
              >
                Companies Stores
              </Button>
              <Button
                className={
                  state.activeTab === 2
                    ? "menu-default-active menu-default"
                    : "menu-default"
                }
                disabled={UtilityServices.getLoggedInUser("user_type") === "c"}
                onClick={(e: any) => handleTabs(2)}
              >
                Customers
              </Button>
            </div>
          </FlexboxGrid.Item>
          <FlexboxGrid.Item colspan={5}>
            <span>From :</span>{" "}
            <DatePicker
              placeholder="Select From Date"
              style={{ width: 170 }}
              value={state.selectedFromDate}
              format={dateFormatObj.calendar_d_m_y}
              onChange={(e: any) => {
                handleDateChange(e, "from");
              }}
            />
          </FlexboxGrid.Item>
          <FlexboxGrid.Item colspan={5}>
            <span>To :</span>{" "}
            <DatePicker
              placeholder="Select From Date"
              style={{ width: 170 }}
              value={state.selectedToDate}
              format={dateFormatObj.calendar_d_m_y}
              onChange={(e: any) => {
                handleDateChange(e, "to");
              }}
            />
          </FlexboxGrid.Item>
          <FlexboxGrid.Item colspan={6} style={{ textAlign: "end" }}>
            <ButtonGroup>
              {state &&
                state.graphFilterOptions &&
                state.graphFilterOptions.map((item: any, index: any) => {
                  return (
                    <Button
                      onClick={(e: any) => {
                        handleGraphType(e, item);
                      }}
                      style={{
                        background:
                          state.selectedFilterOption === item
                            ? "#A3A3A3"
                            : undefined,
                      }}
                      key={index}
                    >
                      {item}
                    </Button>
                  );
                })}
            </ButtonGroup>
          </FlexboxGrid.Item>
        </FlexboxGrid>
      </Header>
      <Content className="main-section">
        <FlexboxGrid justify="space-between" className="dir-col">
          {state.activeTab === 2 ? (
            <FlexboxGrid.Item style={{ textAlign: "start" }}>
              <h4>{state.selectedFilterOption} New Customer</h4>
              {aggegateReportData.dataLine.datasets[0].data.length &&
              aggegateReportData.dataLine.datasets[1].data.length ? (
                <Line
                  data={{
                    labels: aggegateReportData.dataLine.labels,
                    datasets: [
                      {
                        data: aggegateReportData.dataLine.datasets[0].data,
                        label: "Data 1",
                        fill: true,
                        tension: 0.3,
                        backgroundColor: "rgba(225, 204,230, .3)",
                        borderColor: "rgb(205, 130, 158)",
                        borderCapStyle: "butt",
                        borderDash: [],
                        borderDashOffset: 0.0,
                        borderJoinStyle: "miter",
                        pointBorderColor: "rgb(205, 130,1 58)",
                        pointBackgroundColor: "rgb(255, 255, 255)",
                        pointBorderWidth: 10,
                        pointHoverRadius: 5,
                        pointHoverBackgroundColor: "rgb(0, 0, 0)",
                        pointHoverBorderColor: "rgba(220, 220, 220,1)",
                        pointHoverBorderWidth: 2,
                        pointRadius: 1,
                        pointHitRadius: 10,
                      },
                      {
                        data: aggegateReportData.dataLine.datasets[1].data,
                        label: "Data 2",
                        fill: true,
                        tension: 0.3,
                        backgroundColor: "rgba(211, 153, 176, 1)",
                        borderColor: "rgb(35, 26, 136)",
                        borderCapStyle: "butt",
                        borderDash: [],
                        borderDashOffset: 0.0,
                        borderJoinStyle: "miter",
                        pointBorderColor: "rgb(35, 26, 136)",
                        pointBackgroundColor: "rgb(255, 255, 255)",
                        pointBorderWidth: 10,
                        pointHoverRadius: 5,
                        pointHoverBackgroundColor: "rgb(0, 0, 0)",
                        pointHoverBorderColor: "rgba(220, 220, 220, 1)",
                        pointHoverBorderWidth: 2,
                        pointRadius: 1,
                        pointHitRadius: 10,
                      },
                    ],
                  }}
                  width={800}
                  height={400}
                  options={{
                    responsive: true,
                    scales: {
                      y: { beginAtZero: true },
                    },
                  }}
                />
              ) : (
                "No Data...!"
              )}
            </FlexboxGrid.Item>
          ) : null}
          {state.activeTab === 1 ? (
            <>
              <FlexboxGrid.Item colspan={10}>
                <h4>Active Stores</h4>
                {activeStore.dataBar.datasets[0].data.length ? (
                  <Bar
                    data={activeStore.dataBar}
                    options={activeStore.barChartOptions}
                    width={400}
                    height={400}
                  />
                ) : (
                  "No Data...!"
                )}
              </FlexboxGrid.Item>
              <FlexboxGrid.Item colspan={10}>
                <h4>Monthly New Companies</h4>
                {monthlyNewCompany?.dataPie.datasets[0].data.length ? (
                  <Pie
                    data={monthlyNewCompany?.dataPie}
                    width={400}
                    height={400}
                    options={{ responsive: true }}
                  />
                ) : (
                  "No Data...!"
                )}
              </FlexboxGrid.Item>
            </>
          ) : null}
        </FlexboxGrid>
      </Content>
    </Container>
  );
};

export default Dashboard;
